const loadedScripts: any = {};

export default (src: string, async: boolean, defer: boolean, attrs?: {[key: string]: any}) => {
    return new Promise((resolve, reject) => {
        if (!loadedScripts[src]) {
            const s = document.createElement('script');
            s.src = src;
            s.async = async;
            s.defer = defer;
            s.onload = resolve;
            s.onerror = reject;
            if (attrs) {
                for (const att in attrs) {
                    // eslint-disable-next-line no-prototype-builtins
                    if (attrs.hasOwnProperty(att)) {
                        s.setAttribute(att, attrs[att]);
                    }
                }
            }
            document.head.appendChild(s);
            loadedScripts[src] = true;
        } else {
            resolve(true);
        }
    });
};
